import apiInstance from '../services/apiInstance';

export const useStudioActions = () => {
    const analyzeDoc = async (formData: FormData) => {
        const response = await apiInstance.post('/studio/analyze', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    };

    const chatWithDoc = async (message: string, docContext: string, history: any[]) => {
        const response = await apiInstance.post('/studio/chat', {
            message,
            docContext,
            history
        });
        return response.data;
    };

    const generateStudyKit = async (docContext: string) => {
        const response = await apiInstance.post('/studio/study-kit', { docContext });
        return response.data;
    };

    const startInterview = async (resumeContext: string, role: string) => {
        const response = await apiInstance.post('/studio/interview-start', { resumeContext, role });
        return response.data;
    };

    const evaluateInterview = async (history: any[], resumeContext: string) => {
        const response = await apiInstance.post('/studio/interview-evaluate', { history, resumeContext });
        return response.data;
    };

    const generateArchitectBlueprint = async (codeContext: string, requirements: string) => {
        const response = await apiInstance.post('/studio/architect-blueprint', { codeContext, requirements });
        return response.data;
    };

    return { analyzeDoc, chatWithDoc, generateStudyKit, startInterview, evaluateInterview, generateArchitectBlueprint };
};
